import * as z from 'zod';

/** The status-priority modal is self-contained (reads/writes the shared store). */
export const statusPriorityPayloadSchema = z.object({});
export type StatusPriorityPayload = z.infer<typeof statusPriorityPayloadSchema>;
